import type { PsfSharePageState } from './types';

export const INITIAL_STATE: PsfSharePageState = {
	shared: false,
};
